/**
 * Utility functions for date and time handling
 */

/**
 * Format a date string for datetime-local input
 * @param dateString ISO date string
 * @returns Formatted string for datetime-local input (YYYY-MM-DDTHH:MM)
 */
export function formatDateTimeForInput(dateString: string | null | undefined): string {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Format a date string for display with time
 * @param dateString ISO date string
 * @returns Formatted string for display (DD/MM/YYYY HH:MM)
 */
export function formatDateTimeForDisplay(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Format a date string for display without time
 * @param dateString ISO date string
 * @returns Formatted string for display (DD/MM/YYYY)
 */
export function formatDateForDisplay(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleDateString('fr-FR');
}